import type { LeaderboardEntryPublic } from "@softmax/observatory-client/types";
import { parseDatetime } from "@softmax/web-features/time";
import type { WatchMatchup, WatchReplay } from "./records";

export function topTwo(leaderboard: readonly LeaderboardEntryPublic[]): {
  first: LeaderboardEntryPublic;
  second: LeaderboardEntryPublic;
} | null {
  const first = leaderboard.find((entry) => entry.rank === 1);
  const second = leaderboard.find((entry) => entry.rank === 2);

  if (!first || !second) return null;

  return { first, second };
}

type WatchSeries = {
  firstWins: number;
  secondWins: number;
};

export function matchupSeries({
  playlist,
  matchup,
  excludeEpisodeId,
}: {
  readonly playlist: readonly WatchReplay[];
  readonly matchup: WatchMatchup;
  readonly excludeEpisodeId: string | null;
}): WatchSeries {
  const series = { firstWins: 0, secondWins: 0 };

  for (const replay of playlist) {
    if (
      replay.episodeId === excludeEpisodeId ||
      replay.unranked ||
      replay.matchup.first.player_id !== matchup.first.player_id ||
      replay.matchup.second.player_id !== matchup.second.player_id
    ) {
      continue;
    }

    if (replay.outcome === "first") series.firstWins += 1;

    if (replay.outcome === "second") series.secondWins += 1;
  }

  return series;
}

export function newestFirstReplays(
  replays: readonly WatchReplay[],
): WatchReplay[] {
  return [...replays].toSorted(
    (a, b) =>
      (parseDatetime(b.finishedAt)?.getTime() ?? 0) -
      (parseDatetime(a.finishedAt)?.getTime() ?? 0),
  );
}
